import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";
import { AdoptionWidget } from "@/components/AdoptionWidget";
import { DeliveryMetricsSection } from "@/components/metrics/DeliveryMetricsSection";
import { PageHeader } from "@/components/ui/page-header";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { useProjects } from "@/hooks/useProjects";

export function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAdmin = useIsAdmin();
  const { projects, loading: projectsLoading } = useProjects();

  if (!projectsLoading && projects.length === 0 && isAdmin && user) {
    return <Navigate to={`/${user.org_slug}/onboarding/wizard`} replace />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        icon={LayoutDashboard}
        title={user?.org_name ?? "Dashboard"}
        subtitle={t("dashboard.subtitle")}
        secondaryGlow={false}
      />

      {/* Org-scoped delivery KPIs (S16430.6) -- no projectSlug = org aggregation */}
      <DeliveryMetricsSection />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <AdoptionWidget />
      </div>
    </div>
  );
}
